// extracted by mini-css-extract-plugin
export default {"table_wrapper":"spacesManageSection_table_wrapper__PnhA8"};